import { useLocalStore, useObserver } from 'mobx-react-lite';
import { runInAction, toJS } from 'mobx';
import WebSocketUtil from '../../../../common/utils/socketUtil';
import { ScoreDetailService } from '../../../../common/services';
import { ObjectUtil } from '../../../../common/utils/objectUtil';

const FootballBroadcastStore = () => {
  const store = useLocalStore(() => ({
    broadcast: null,
    loading: true,
    init: false,
    socket: null,
    isSub: false,
    gameId: null,
    selectedPeriod: 1,
    isAuto: false,
    autoCount: 5,
    intervals: null,
    connectSocket(topic) {
      store.socket = new WebSocketUtil(topic);
      store.socket.ws.onmessage = this.handleMessageData;
    },

    handleMessageData(messageEvent) {
      let data = messageEvent.data;
      try {
        if (data === 'OK') {
          store.isSub = true;
        } else {
          let messageData = JSON.parse(data);
          if (messageData) {
            const { TOPIC, MESSAGE } = messageData;
            const data = JSON.parse(MESSAGE);
            if (!!store.gameId) {
              if (TOPIC === `sports.football.broadcasts.${store.gameId}`) {
                data.broadcasts.forEach((item) => {
                  if (store.broadcast.hasOwnProperty(item.period)) {
                    const newPeriod = [item];
                    store.broadcast = {
                      ...store.broadcast,
                      [item.period]: newPeriod.concat(
                        toJS(store.broadcast[item.period])
                      )
                    };
                  } else {
                    store.broadcast[item.period] = [item];
                    store.selectedPeriod = item.period;
                  }
                });
              }
            }
          }
        }
      } catch (error) {
        console.log('=== socket on message error ===', error);
      }
    },

    closeSocket() {
      store.socket.close(() => {
        runInAction(() => {
          store.isSub = false;
          store.socket = null;
        });
      });
    },
    async getBroadcast(gameId) {
      if (!store.isSub) {
        store.connectSocket([`sports.football.broadcasts.${gameId}`]);
      }

      const result = await ScoreDetailService.getBroadcastsBySportsType(
        'football',
        gameId
      );

      const deep = { ...result };
      const keys = Object.keys(deep);
      let broadCast = {};

      keys.forEach((period) => {
        result[period].map((value, key) => {
          if (ObjectUtil.isNotNull(broadCast[period])) {
            broadCast[period].unshift(value);
          } else {
            broadCast[period] = [];
            broadCast[period].unshift(value);
          }
        });
      });

      let progressPeriod = +keys.pop();

      store.selectedPeriod = progressPeriod;
      store.broadcast = broadCast;
      store.gameId = gameId;
      store.loading = false;
    },
    setSelectedPeriod(period) {
      store.selectedPeriod = period;
    }
  }));

  return {
    getBroadcast: store.getBroadcast,
    closeSocket: store.closeSocket,
    broadcast: toJS(store.broadcast),
    selectedPeriod: toJS(store.selectedPeriod),
    data: useObserver(() => {
      return {
        init: store.init,
        loading: store.loading,
        setSelectedPeriod: store.setSelectedPeriod
      };
    })
  };
};

export default FootballBroadcastStore;
